import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "confmail" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check-circle" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "このページを閉じてください。", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, null, {
          default: _withCtx(() => [
            _hoisted_2,
            _createTextVNode(" メールアドレス確認")
          ]),
          _: 1
        }),
        _createVNode(_component_el_main, null, {
          default: _withCtx(() => [
            (!_ctx.message.err)
              ? (_openBlock(), _createBlock(_component_el_alert, {
                  key: 0,
                  title: "メールアドレスを確認できました。",
                  type: "success",
                  closable: false
                }))
              : _createCommentVNode("", true),
            (_ctx.message.err)
              ? (_openBlock(), _createBlock(_component_el_alert, {
                  key: 1,
                  title: _ctx.message.msg,
                  type: "error",
                  closable: false
                }, null, 8, ["title"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_footer, null, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}